import { render, staticRenderFns } from "./PlatenTemplateList.vue?vue&type=template&id=2d82c419&scoped=true&"
import script from "./PlatenTemplateList.vue?vue&type=script&lang=js&"
export * from "./PlatenTemplateList.vue?vue&type=script&lang=js&"
import style0 from "./PlatenTemplateList.vue?vue&type=style&index=0&id=2d82c419&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d82c419",
  null
  
)

export default component.exports